import { Field, FieldFooter, IFormFieldDefaultProps } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { AnyObject } from 'types/util/Object';
import CertificationPicker, { ICertificationPickerProps } from '../CertificationPicker/CertificationPicker';

export interface ICertificationPickerFormFieldProps<FormType extends AnyObject>
  extends Omit<ICertificationPickerProps, 'value' | 'onSelect'>,
    IFormFieldDefaultProps<string | null, FormType> {
  onSelect?: (value: string | null) => void;
}

const CertificationPickerFormField = <FormType extends AnyObject>({
  form,
  name,
  validations,
  onSelect,
  className,
  revalidateOnNewValidations,
  ...other
}: ICertificationPickerFormFieldProps<FormType>) => {
  const classes = classNames('certification-picker-form-field', className);
  function renderField({ ...fieldProps }) {
    function handleOnSelect(val: string | null) {
      fieldProps.handleChange(val, onSelect);
    }

    return (
      <>
        <CertificationPicker
          error={fieldProps.hasError}
          value={form.state.data[name]}
          onSelect={handleOnSelect}
          {...other}
        />
        <FieldFooter errorMessage={fieldProps.errorMessage} hasError={fieldProps.hasError} />
      </>
    );
  }

  return (
    <Field
      form={form}
      name={name}
      validations={validations}
      className={classes}
      render={renderField}
      revalidateOnNewValidations={revalidateOnNewValidations}
    />
  );
};

export default CertificationPickerFormField;
